import { render, staticRenderFns } from "./KayttajatSelaa.vue?vue&type=template&id=09846c35&scoped=true&"
import script from "./KayttajatSelaa.vue?vue&type=script&lang=js&"
export * from "./KayttajatSelaa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09846c35",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VDataTable,VNavigationDrawer,VProgressLinear,VSpacer,VToolbar})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09846c35')) {
      api.createRecord('09846c35', component.options)
    } else {
      api.reload('09846c35', component.options)
    }
    module.hot.accept("./KayttajatSelaa.vue?vue&type=template&id=09846c35&scoped=true&", function () {
      api.rerender('09846c35', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/KayttajatSelaa.vue"
export default component.exports